export default {
  // Sidebar Navigation
  sidebar: {
    dashboard: "Painel",
    recommendations: "Recomendações",
    organizationDesign: "Design da Organização",
    talentPool: "Pool de Talentos",
    reports: "Relatórios",
    notifications: "Notificações",
    switchOrg: "Mudar Organização"
  },
  // Talent Pool / Users Page
  talentPool: {
    relationshipAddedSuccessfully: "Relacionamento adicionado com sucesso",
    relationshipRemovedSuccessfully: "Relacionamento removido com sucesso",
    relationshipSavedSuccessfully: "Relacionamento Salvo com Sucesso",
    profileCard: "Cartão de Perfil",
    viewOptions: {
      plan: "Plano",
      hierarchy: "Hierarquia",
      network: "Rede"
    },
    searchPlaceholder: "Pesquisar usuários...",
    networkSearchPlaceholder: "Pesquisar rede...",
    hierarchySearchPlaceholder: "Pesquisar hierarquia...",
    // KVDR Notifications
    kvdrNotifications: {
      create: "Criar",
      roleCreatedSuccessfully: "Função criada com sucesso",
      delete: "Excluir",
      roleDeletedSuccessfully: "Função excluída com sucesso",
      addProfile: "Adicionar Perfil",
      profileAddedSuccessfully: "Perfil adicionado com sucesso",
      removeProfile: "Remover Perfil",
      profileRemovedSuccessfully: "Perfil removido com sucesso",
      roleUpdate: "Atualização de Função",
      updatedSuccessfully: "Atualizado com sucesso",
      profileUpdate: "Atualização de Perfil",
      profileUpdatedSuccessfully: "Perfil atualizado com sucesso"
    },
    title: "Pool de talentos",
    reviewRequest: "Solicitação de revisão",
    // Main talent pool
    noPendingRequest: "Nenhuma solicitação pendente encontrada",
    importFrom: "Importar de",
    uploadExcel: "enviar excel",
    uploadResumes: "enviar currículos",
    uploadResumesTooltip: "Importar desde currículos (PDF)",
    orHRIS: "ou HRIS",
    pendingRequest: "Solicitação pendente",
    allUsers: "Todos os usuários",
    addNewEmployee: "Adicionar novo cartão de funcionário",
    // Table headers
    name: "Nome",
    email: "E-mail",
    maxRole: "Função máxima",
    relationships: "Relacionamentos",
    action: "Ação",
    // User search
    searchUser: "Pesquisar usuário",
    userNotFound: "Usuário não encontrado.",
    // Relationship management
    member: "Membro",
    relationship: "Relacionamento",
    addRelation: "Adicionar relacionamento",
    removeRelationship: "Remover relacionamento"
  },
  // Settings Help Page
  settingsHelp: {
    frequentlyAskedQuestions: "Perguntas Frequentes",
    question1: "Como gerencio as configurações da minha organização?",
    question2: "Como posso convidar novos membros para minha organização?",
    question3: "Quais são os diferentes papéis e permissões de usuário?",
    question4: "Como personalizo a marca da minha organização?",
    helpText: "Este é um texto de ajuda de exemplo. Entre em contato com o suporte para assistência específica com as configurações e configuração da sua organização."
  },
  // Create Organization
  createOrganization: {
    organizationName: "Nome da organização",
    organizationUsername: "Nome de usuário da organização",
    website: "Site",
    workEmail: "Email de trabalho",
    location: "Localização",
    organizationType: "Tipo de organização",
    primaryThemeColor: "Cor do tema principal",
    secondaryThemeColor: "Cor do tema secundário",
    about: "Sobre",
    saveChanges: "Salvar alterações",
    usernameExists: "Este nome de usuário já existe",
    usernameAvailable: "Este nome de usuário está disponível",
    organizationTypeOptions: {
      business: "Negócio",
      academic: "Acadêmico",
      recruiter: "Recrutador"
    },
    logo: {
      adjustTitle: "Ajustar logo da organização",
      save: "Salvar",
      uploadButton: "Enviar logo",
      incorrectFileType: "Tipo de arquivo incorreto",
      incorrectFileTypeText: "Por favor envie um tipo de arquivo de imagem suportado, ex. jpg, png, etc.",
      fileSizeExceeded: "Tamanho do arquivo de imagem excedido",
      fileSizeExceededText: "O tamanho da imagem de perfil deve ser menor que 1MB."
    }
  },

  // Main Organizations List
  main: {
    select: "Selecionar",
    acceptInvitation: "Aceitar convite",
    noOrganizationFound: "Nenhuma organização encontrada!",
    noOrganizationSubtext: "Crie sua própria organização primeiro.",
    createOrganization: "Criar organização"
  },

  // Organization Dashboard
  organization: {
    welcomeBack: "Bem-vindo de volta! 👋",
    setupComplete: "Configuração completa!",
    setupProgress: "Configuração: {step} de 4",
    copyLink: "Copiar link",
    linkCopied: "Link copiado",
    criticalRoles: "Funções críticas",
    talentPool: "Pool de talentos",
    integrations: "Integrações",
    onboarding: "Integração",
    activeCandidates: "Candidatos ativos",
    connectedApps: "Aplicativos conectados",
    pendingOnboards: "Integrações pendentes",
    kvdrReportsCenter: "Centro de relatórios KVDR",
    kvdrReportsDescription: "Mergulhe em seus relatórios de dados visuais chave e obtenha insights críticos.",
    exploreReports: "Explorar relatórios >",
    talentPoolExplorer: "Explorador de pool de talentos",
    talentPoolDescription: "Descubra, analise e gerencie seus melhores talentos com insights abrangentes.",
    exploreTalentPool: "Explorar pool de talentos >",
    thisMonth: "este mês",
    goToOnboarding: "Ir para integração"
  },

  // Reports
  reports: {
    title: "Relatórios",
    nineCellMatrix: "Matriz de nove células",
    xyPlot: "Gráfico XY",
    talentScoreCard: "Cartão de pontuação de talentos",
    emptyReports: "Relatórios vazios",
    createKVDRFirst: "Crie primeiro um KVDR e planeje para ver relatórios",
    // XY Plot specific
    xAxis: "Eixo X",
    yAxis: "Eixo Y",
    bubbleSize: "Tamanho da bolha",
    loadingChart: "Carregando gráfico...",
    howToReadChart: "Como ler este gráfico",
    positioning: "Posicionamento",
    horizontalPosition: "A posição horizontal mostra",
    verticalPosition: "A posição vertical mostra",
    bubbleRepresentation: "Representação de bolhas",
    eachBubbleRepresents: "Cada bolha representa um funcionário",
    sizeIndicates: "O tamanho indica",
    quadrants: "Quadrantes",
    topLeft: "Superior-Esquerda",
    topRight: "Superior-Direita",
    bottomLeft: "Inferior-Esquerda",
    bottomRight: "Inferior-Direita",
    low: "Baixo",
    high: "Alto",
    interaction: "Interação",
    hoverOverBubble: "Passe o mouse sobre uma bolha",
    revealsDetailedMetrics: "Revela métricas detalhadas para esse funcionário",
    colorCoding: "Codificação de cores",
    differentColorsHelp: "Cores diferentes ajudam a distinguir funcionários",
    // Nine Cell Matrix specific
    nineCellMatrixTitle: "Categorização de funcionários por matriz de nove células",
    methodologyDescription: "Metodologia padronizada baseada em pontuação de desempenho e prontidão para sucessão",
    loading: "Carregando...",
    preparingMatrix: "Preparando a matriz de nove células...",
    noDataAvailable: "Nenhum dado disponível",
    employeeAssessmentRequired: "Dados de avaliação de funcionários são necessários para exibir a matriz de nove células.",
    successionReadiness: "Prontidão para sucessão",
    performanceScore: "Pontuação de desempenho",
    bargain: "BARGAIN",
    bind: "VINCULAR",
    backup: "BACKUP",
    onTrack: "NO CAMINHO",
    boost: "IMPULSIONAR",
    build: "CONSTRUIR",
    bootBarter: "BOOT/TROCA",
    employees: "Funcionários",
    methodologyTitle: "Metodologia da matriz de nove células",
    methodologySubtitle: "Categorização padronizada de funcionários baseada em cálculos de pontuação de desempenho e prontidão para sucessão.",
    calculationMethod: "Método de cálculo",
    performanceScoreFormula: "Pontuação de desempenho (P)",
    performanceScoreCalculation: "P = 0,6 × Desempenho + 0,4 × Avaliação",
    performanceScoreNote: "As pontuações brutas (-1 a 1,5) são normalizadas para escala 0-100",
    successionReadinessFormula: "Prontidão para sucessão (R)",
    successionReadinessCalculation: "R = 0,5 × Sucessão + 0,3 × Adequação + 0,2 × Pontuação de anos",
    successionReadinessNote: "As pontuações brutas (-1 a 1,5) são normalizadas para escala 0-100",
    yearsScore: "Pontuação de anos",
    yearsScoreCalculation: "Se Anos ≥ 3: 100, senão: (Anos / 3) × 100",
    yearsScoreNote: "Atualmente usa 2 anos por padrão (configurável)",
    cellCategories: "Categorias de células",
    backupDescription: "Alto desempenho, Alta sucessão",
    boostDescription: "Desempenho médio, Alta sucessão",
    bindDescription: "Alta/Média sucessão, Desempenho baixo/médio",
    onTrackDescription: "Desempenho médio/baixo, Sucessão média/baixa",
    buildDescription: "Desempenho médio, Sucessão baixa",
    bargainDescription: "Desempenho baixo, Alta sucessão",
    bootBarterDescription: "Alto desempenho, Sucessão baixa",
    // Talent Score Card specific
    criteria: "Critérios",
    talent: "TALENTO",
    role: "FUNÇÃO",
    remarks: "OBSERVAÇÕES",
    weightage: "Ponderação",
    good: "Bom (8-10)",
    average: "Médio (5-7)",
    poor: "Ruim (1-4)",
    notApplicable: "Não aplicável"
  },


  // Users
  users: {
    title: "Usuários",
    manageUsers: "Gerenciar usuários",
    // User Recommendations
    talentRecommendations: "Recomendações de talento",
    recommendationsDescription: "Com base na sua avaliação KVDR, aqui estão recomendações personalizadas para sua organização",
    viewActivePlans: "Ver planos ativos",
    // Recommendation Cards
    fitmentPlan: "Plano de adequação",
    fitmentPlanDescription: "Integração de pessoas em seus papéis.",
    fitmentPlanContent: "Integração de pessoas em seus papéis. Mapeamento do talento certo para os papéis certos com indicadores de adequação",
    developmentPlan: "Plano de desenvolvimento",
    developmentPlanDescription: "Aprendizagem alimentada por IA com ALEX",
    developmentPlanContent: "Criação de planos de aprendizagem com ALEX Caminhos de aprendizagem personalizados para aumentar o valor do talento com habilidades.",
    successionPlanning: "Planejamento de sucessão",
    successionPlanningDescription: "Promover e apoiar o crescimento da carreira",
    successionPlanningContent: "Promover e apoiar o crescimento da carreira Planos de coaching para prontidão de habilidades e tempo para o próximo papel.",
    // Benefits Lists
    roadToRole: "Caminho para seu papel (Jornada)",
    skillProfiling: "Perfilamento de habilidades",
    learningCredits: "Créditos de aprendizagem",
    marketRewards: "Recompensas do mercado",
    customLearningPaths: "Caminhos de aprendizagem personalizados",
    aiAssistedValidation: "Validação assistida por IA",
    progressTracking: "Acompanhamento do progresso com Pontos de Experiência (XPs)",
    interactiveExercises: "Exercícios interativos",
    appraisalIndicators: "Indicadores de avaliação 360°",
    goalSettingMentorship: "Definição de metas e mentoria",
    behaviouralCoaching: "Coaching comportamental e planos",
    managedCareerGuidance: "Orientação de carreira gerenciada",
    // Action Buttons
    onboard: "Integrar",
    activate: "Ativar",
    promote: "Promover",
    // Progress Section
    talentCapabilitySnapshot: "Instantâneo de capacidades de talento",
    lastUpdated: "Última atualização: Hoje",
    refresh: "Atualizar",
    // Score Labels
    industryLeader: "Líder da indústria",
    highPerforming: "Alto desempenho",
    competitive: "Competitivo",
    developing: "Em desenvolvimento",
    foundationBuilding: "Construção de fundamentos",
    // Notifications
    alexActivated: "ALEX ativado",
    alexActivatedText: "Seu assistente de aprendizagem de IA está pronto para ajudar!",
    coachingRequestSent: "Solicitação de coaching enviada",
    coachingRequestSentText: "Um coach entrará em contato em breve!",
    rewardsMarketplace: "Marketplace de recompensas",
    rewardsMarketplaceText: "Explorando recompensas e benefícios disponíveis!"
  },

  // Integrations
  integrations: {
    title: "Integrações",
    manageIntegrations: "Gerenciar integrações"
  },

  // Admins
  admins: {
    title: "Administradores",
    manageAdmins: "Gerenciar administradores"
  }
};
